export interface PasswordValidation {
  minLength: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasNumber: boolean;
  hasSymbol: boolean;
  noSequence: boolean;
  noTBA: boolean;
  noNameParts: boolean;
  noTheBest: boolean;
  passwordsMatch: boolean;
}

interface UserData {
  name?: string;
  last_name?: string;
}

const normalize = (str: string) => {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

const createSubstrings = (text, minLength) => {
  const allSubstrings: string[] = [];

  for (let start = 0; start < text.length; start++) {
    for (let end = start + minLength; end <= text.length; end++) {
      const _substring = text.slice(start, end);
      allSubstrings.push(_substring);
    }
  }

  return allSubstrings;
};

export const validatePassword = (
  newPassword: string,
  confirmPassword: string,
  userData?: UserData | null,
  name?: string,
  lastName?: string
): PasswordValidation => {
  const validate: PasswordValidation = {
    minLength: newPassword.length >= 6,
    hasUppercase: /[A-Z]/.test(newPassword),
    hasLowercase: /[a-z]/.test(newPassword),
    hasNumber: /\d/.test(newPassword),
    hasSymbol: /[!@#$%^&*()_+{}[\]:;<>,.?~\\-]/.test(newPassword),
    noSequence: !/(123456|654321|abcdef|fedcba)/.test(
      newPassword.toLowerCase()
    ),
    noTBA: !newPassword.toLowerCase().includes("tba"),
    noTheBest: !(
      /the\s*best/i.test(newPassword) || /thebest/i.test(newPassword)
    ),
    noNameParts: true,
    passwordsMatch: newPassword === confirmPassword && newPassword !== "",
  };

  if (userData?.name || name) {
    const normalizedPassword = normalize(newPassword);

    const fullNameNormalized = normalize(
      `${userData?.name || name || ""} ${userData?.last_name || lastName || ""}`
    ).replace(/\s+/g, "");

    const forbiddenSubstrings = createSubstrings(fullNameNormalized, 3);

    const containsForbiddenNamePart = forbiddenSubstrings.some((substring) =>
      normalizedPassword.includes(substring)
    );

    validate.noNameParts = !containsForbiddenNamePart;
  }

  return validate;
};

export const allValidationsPassed = (
  validations: PasswordValidation
): boolean => {
  return Object.values(validations).every((value) => value === true);
};
